/* ────────────────────────────────────────────────────────────
   Shared styles
──────────────────────────────────────────────────────────── */

export const styles = {
  root: {
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    maxWidth: 430,
    margin: "0 auto",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    background: "#f4f5f9",
    position: "relative",
  },

  /* Header (gradient, generic) */
  headerGradient: {
    background: "linear-gradient(135deg, #2B35AF 0%, #3d52d5 100%)",
    padding: "52px 20px 36px",
    position: "relative",
    overflow: "hidden",
  },
  header: {
    background: "linear-gradient(135deg, #2B35AF 0%, #3d52d5 100%)",
    padding: "52px 20px 0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  headerTitle: {
    color: "#fff",
    fontSize: 24,
    fontWeight: 700,
    margin: 0,
    position: "relative",
    zIndex: 1,
  },
  headerTuck: {
    position: "absolute",
    right: 0,
    bottom: 0,
    display: "block",
  },
  backBtn: {
    width: 32,
    height: 32,
    borderRadius: "50%",
    border: "1.5px solid rgba(255,255,255,0.35)",
    background: "transparent",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  greeting: { color: "rgba(255,255,255,0.85)", fontSize: 13, margin: 0 },
  userName: { color: "#fff", fontSize: 22, fontWeight: 700, margin: "4px 0 0" },
  headerIcons: { display: "flex", gap: 8, alignItems: "center", paddingTop: 4 },
  iconBtn: {
    width: 36,
    height: 36,
    borderRadius: "50%",
    border: "1.5px solid rgba(255,255,255,0.35)",
    background: "transparent",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  /* Search */
  searchBox: {
    background: "rgba(255,255,255,0.18)",
    borderRadius: 30,
    padding: "10px 16px",
    display: "flex",
    alignItems: "center",
    border: "1px solid rgba(255,255,255,0.25)",
  },
  searchInput: { background: "transparent", border: "none", outline: "none", color: "#fff", fontSize: 14, flex: 1 },

  /* Body */
  body: {
    flex: 1,
    background: "#f4f5f9",
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    marginTop: -16,
    padding: "24px 16px 110px",
    display: "flex",
    flexDirection: "column",
  },

  /* Promo */
  promoBanner: {
    background: "linear-gradient(135deg, #2B35AF 0%, #4a6fa5 100%)",
    borderRadius: 16,
    padding: "20px 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 28,
  },
  promoTitle: { color: "#fff", fontWeight: 700, fontSize: 16, margin: 0 },
  promoSub: { color: "rgba(255,255,255,0.8)", fontSize: 12, margin: "4px 0 0", lineHeight: 1.4 },
  bookNowBtn: {
    background: "#2ec4a0",
    color: "#fff",
    border: "none",
    borderRadius: 24,
    padding: "12px 20px",
    fontWeight: 600,
    fontSize: 14,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },

  /* Services */
  sectionTitle: { fontSize: 18, fontWeight: 700, color: "#111", margin: "0 0 16px 4px" },
  servicesGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 28 },
  serviceCard: {
    background: "#fff",
    border: "none",
    borderRadius: 16,
    padding: "20px 16px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 12,
    cursor: "pointer",
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  },
  serviceIconWrap: { width: 64, height: 64, borderRadius: 14, display: "flex", alignItems: "center", justifyContent: "center" },
  serviceLabel: { fontSize: 13, fontWeight: 500, color: "#222" },

  /* Generic primary buttons */
  bookServiceBtn: {
    width: "100%",
    background: "#2B35AF",
    color: "#fff",
    border: "none",
    borderRadius: 30,
    padding: "16px",
    fontSize: 16,
    fontWeight: 600,
    cursor: "pointer",
  },
  trackBtn: {
    width: "100%",
    background: "#2B35AF",
    color: "#fff",
    border: "none",
    borderRadius: 30,
    padding: "16px",
    fontSize: 16,
    fontWeight: 600,
    cursor: "pointer",
    marginBottom: 16,
  },
  confirmOrderBtn: {
    width: "100%",
    background: "#2B35AF",
    color: "#fff",
    border: "none",
    borderRadius: 30,
    padding: "16px",
    fontSize: 16,
    fontWeight: 600,
    cursor: "pointer",
    marginTop: 8,
  },
  errorText: {
    color: "#E25555",
    fontSize: 13,
    margin: "0 0 10px",
    textAlign: "center",
  },

  /* Cards (generic) */
  card: {
    width: "100%",
    background: "#fff",
    borderRadius: 16,
    padding: "18px 20px",
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
    marginBottom: 16,
  },
  cardTitle: { fontSize: 15, fontWeight: 700, color: "#111", margin: "0 0 14px" },
  cardRow: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: "1px solid #f0f0f0" },
  cardLabel: { fontSize: 13.5, color: "#777" },
  cardLabelBold: { fontSize: 13.5, color: "#111", fontWeight: 600 },
  cardValue: { fontSize: 13.5, fontWeight: 700, color: "#111", textAlign: "right" },
  cardAmount: { fontSize: 16, fontWeight: 700, color: "#2B35AF" },

  /* Pills */
  pillRow: { display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 8 },
  pill: {
    background: "#F2F3F8",
    border: "1px solid #e3e5ef",
    borderRadius: 20,
    padding: "9px 16px",
    fontSize: 13,
    color: "#444",
    cursor: "pointer",
  },
  pillActive: {
    background: "#E8E9FB",
    border: "1.5px solid #3B4FBF",
    borderRadius: 20,
    padding: "9px 16px",
    fontSize: 13,
    color: "#2B35AF",
    fontWeight: 600,
    cursor: "pointer",
  },

  /* Inputs */
  inputRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    background: "#F6F7FB",
    border: "1px solid #ECEDF4",
    borderRadius: 12,
    padding: "12px 14px",
    marginBottom: 10,
  },
  inputField: { flex: 1, border: "none", outline: "none", background: "transparent", fontSize: 13.5, color: "#222" },
  standaloneInput: {
    width: "100%",
    background: "#F6F7FB",
    border: "1px solid #ECEDF4",
    borderRadius: 12,
    padding: "12px 14px",
    marginBottom: 10,
    boxSizing: "border-box",
  },
  textarea: {
    width: "100%",
    background: "#F6F7FB",
    border: "1px solid #ECEDF4",
    borderRadius: 12,
    padding: "12px 14px",
    fontSize: 13.5,
    color: "#222",
    minHeight: 60,
    resize: "vertical",
    boxSizing: "border-box",
    fontFamily: "inherit",
  },
  selectField: {
    width: "100%",
    background: "#F6F7FB",
    border: "1px solid #ECEDF4",
    borderRadius: 12,
    padding: "12px 14px",
    fontSize: 13.5,
    color: "#222",
    marginBottom: 10,
    boxSizing: "border-box",
  },

  /* Toggle */
  toggleRow: { display: "flex", alignItems: "center", gap: 10, background: "none", border: "none", cursor: "pointer", padding: "8px 0", marginBottom: 4 },
  toggleTrack: { position: "relative", width: 38, height: 22, borderRadius: 12, transition: "background 0.15s" },
  toggleThumb: { position: "absolute", top: 2, width: 18, height: 18, borderRadius: "50%", background: "#fff", transition: "left 0.15s" },
  toggleLabel: { fontSize: 14, color: "#222" },

  /* Photos */
  selectImagesBtn: {
    width: "100%",
    background: "#F6F7FB",
    border: "1px dashed #cfd2e3",
    borderRadius: 12,
    padding: "14px",
    fontSize: 13.5,
    color: "#666",
    cursor: "pointer",
    marginBottom: 12,
  },
  photoGrid: { display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 8 },
  photoThumbWrap: { position: "relative", borderRadius: 10, overflow: "hidden", aspectRatio: "1" },
  photoThumb: { width: "100%", height: "100%", objectFit: "cover", display: "block" },
  photoRemoveBtn: {
    position: "absolute",
    top: 2,
    right: 2,
    width: 18,
    height: 18,
    borderRadius: "50%",
    background: "rgba(0,0,0,0.6)",
    color: "#fff",
    border: "none",
    fontSize: 12,
    lineHeight: "18px",
    cursor: "pointer",
    padding: 0,
  },

  /* Booking confirmed */
  checkCircle: { width: 88, height: 88, borderRadius: "50%", background: "#6FE0AE", display: "flex", alignItems: "center", justifyContent: "center" },
  title: { fontSize: 22, fontWeight: 700, color: "#111", margin: 0, textAlign: "center" },
  orderId: { fontSize: 13, color: "#777", margin: "6px 0 24px", textAlign: "center" },
  riderBanner: { width: "100%", background: "#CFF7EA", borderRadius: 30, padding: "14px 20px", textAlign: "center", marginBottom: 24 },
  riderText: { color: "#15A883", fontWeight: 600, fontSize: 14 },
  cancelBtn: { background: "none", border: "none", color: "#E25555", fontSize: 13.5, textDecoration: "underline", cursor: "pointer", padding: 0 },

  /* Live tracking */
  mapWrap: { position: "relative", margin: "0 0 8px", cursor: "pointer", overflow: "hidden" },
  etaBadge: {
    position: "absolute",
    top: 12,
    right: 16,
    background: "#fff",
    borderRadius: 20,
    padding: "6px 14px",
    fontSize: 12.5,
    fontWeight: 600,
    color: "#2B35AF",
    boxShadow: "0 1px 6px rgba(0,0,0,0.12)",
  },
  truckMarker: { position: "absolute", left: "28%", top: "42%", fontSize: 22 },
  pinMarker: { position: "absolute", left: "68%", top: "44%" },
  riderCardRow: { display: "flex", alignItems: "center", gap: 12, paddingBottom: 16, borderBottom: "1px solid #eee" },
  riderPhoto: { width: 48, height: 48, borderRadius: "50%", objectFit: "cover" },
  riderName: { fontSize: 14.5, fontWeight: 700, color: "#111", margin: "0 0 2px" },
  riderVehicle: { fontSize: 12.5, color: "#888", margin: 0 },
  timelineRow: { display: "flex", gap: 14 },
  timelineDotCol: { display: "flex", flexDirection: "column", alignItems: "center" },
  timelineDot: { width: 14, height: 14, borderRadius: "50%", flexShrink: 0 },
  timelineLine: { width: 2, flex: 1, minHeight: 22 },
  timelineLabel: { fontSize: 14, fontWeight: 600, margin: 0 },
  timelineSub: { fontSize: 12, color: "#15A883", margin: "2px 0 0" },

  /* Rating */
  ratingPhoto: { width: 64, height: 64, borderRadius: "50%", objectFit: "cover", margin: "0 auto 10px", display: "block" },
  ratingName: { fontSize: 14, fontWeight: 600, color: "#111", margin: "0 0 12px" },

  /* Wallet */
  walletCard: { width: "100%", background: "#fff", borderRadius: 16, padding: "18px 20px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", marginBottom: 16 },
  paypalLogo: { fontSize: 20, fontWeight: 700, fontStyle: "italic", color: "#003087" },
  visaLogo: { fontSize: 18, fontWeight: 800, fontStyle: "italic", color: "#1A1F71", margin: 0, letterSpacing: 1 },
  visaSub: { fontSize: 10, color: "#1A1F71", margin: "-2px 0 0", letterSpacing: 2 },
  trashBtn: { background: "none", border: "none", cursor: "pointer", padding: 4 },
  walletDetail: { fontSize: 14, color: "#333", margin: "14px 0 4px" },
  walletSub: { fontSize: 12, color: "#999", margin: 0 },

  /* Bottom nav */
  bottomNav: {
    position: "fixed",
    bottom: 0,
    left: "50%",
    transform: "translateX(-50%)",
    width: "100%",
    maxWidth: 430,
    background: "#fff",
    borderTop: "1px solid #eee",
    display: "flex",
    justifyContent: "space-around",
    padding: "10px 0 20px",
    zIndex: 100,
  },
  navItem: { background: "none", border: "none", cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: 3, padding: "4px 8px", position: "relative" },
  navLabel: { fontSize: 13 },
  navUnderline: { position: "absolute", bottom: -10, left: "50%", transform: "translateX(-50%)", width: "70%", height: 2.5, background: "#2B35AF", borderRadius: 2 },
};